module.exports = __webpack_public_path__ + "img/btn-shine.2c8f547b.png";